import { shouldPolyfill as shouldPolyfillIntlDateTimeFormat } from '@formatjs/intl-datetimeformat/should-polyfill.js';
import { shouldPolyfill as shouldPolyfillIntlGetCanonicalLocales } from '@formatjs/intl-getcanonicallocales/should-polyfill.js';

async function dynamicIntlPolyfills(): Promise<void> {
  if (shouldPolyfillIntlGetCanonicalLocales()) {
    await import('@formatjs/intl-getcanonicallocales/polyfill.js');
  }
  if (shouldPolyfillIntlDateTimeFormat()) {
    await import('@formatjs/intl-datetimeformat/polyfill.js');
    await Promise.all([import('@formatjs/intl-datetimeformat/add-golden-tz.js'), import('@formatjs/intl-datetimeformat/locale-data/en.js')]);
  }
}

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */
import '@angular/localize/init';
import 'core-js/es/array';
import 'core-js/es/string';
import 'core-js/features/url';
import 'whatwg-fetch';
dynamicIntlPolyfills().catch((error) => {
  throw error;
});

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).global = window;
